import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  makeStyles } from '@material-ui/core';
import Box from '@mui/material/Box';
import RoundButton from '../../../Common/RoundButton';
import { useHistory } from 'react-router-dom';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ErrorMessage from '../../../Common/ErrorMessage';
import { updateAgreementRequest } from './laActions';
import { PGAPI } from '../../../utils/urls';
import { AppState } from '../../../store/rootReducer';
import { logFirebaseEvent } from '../firebase';
import { P2P_LENDER_AGREEMENT_BTN, P2P_LENDER_AGREEMENT_VIEW } from '../firebase/constant';
import ProgressBar from '../../../Common/ProgressBar';
import LenderAgreementImg from "../../../utils/assests/lender-agreement.png";
import { Grid, Typography } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: "flex-end", // push the dialog to bottom
  },
  paper: {
    // make the content full width
    margin: 0,
    maxWidth: "100%",
    width: "100%",
    height: "150px"
  }
}));

const LenderAgreement = () => {
  const api = `${PGAPI}/tnc`
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [checkBoxValue, setCheckBoxValue] = useState<boolean>(true)
  const handleProceed = () => {
    logFirebaseEvent(P2P_LENDER_AGREEMENT_BTN)
    if (checkBoxValue) {
      dispatch(updateAgreementRequest());
    }
  };

  const {updateResponse,updateError} = useSelector((state:AppState) => state.lenderAgreement)

  useEffect(()=> {
    document.title = "stashearn - lender-agreement"
  },[])

  useEffect(() => {
    logFirebaseEvent(P2P_LENDER_AGREEMENT_VIEW)
  },[])
  useEffect(() => {
    if(updateResponse?.status && updateResponse?.results?.landing_page === 5){
      history.push({pathname:'/p2p/dashboard'});
    }
  },[updateResponse]);

  const handleChangeCheckbox = () => {
    setCheckBoxValue(!checkBoxValue)
  };

  return (
    <>
      <BackgroundTheme>
      <ProgressBar
          progress={100}
        />

        <Box className='legarAuth'>
        <Typography
              variant="h1"
              className="text-blue text-center fs-25 fw-800 MuiTypography-h1"
            >
              Lender registration agreement
            </Typography>
            <img src={LenderAgreementImg} alt='' />
            <Typography
              variant='h2'
              className='text-center fs-20 fw-300 text-gray-four'
            >
              You are 1 step away from <br /> earning attractive returns
            </Typography>
            <a href={api}>Read all documents</a>
            <div className='termsAndConditions'>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  checked={checkBoxValue}
                  onChange={handleChangeCheckbox}
                  color='default'
                  sx={{ fontSize: '10px' }}
                />
              }
              label={<p>I accept the Terms </p>}
            />
          </FormGroup>
        </div>
        </Box>
        {
          !checkBoxValue && <ErrorMessage text="Please accept the Terms" />
        }
        {
          updateError && <ErrorMessage text={updateError} />
        }
        <div style={{ marginBottom: "10px", marginTop: '20px' }}>
          <RoundButton onClick={handleProceed} title={'Proceed'} />
        </div>
      </BackgroundTheme>
    </>
  );
};

export default LenderAgreement;